import { FlexRowAlignCenter } from "@/components/Flex";
import LinkWrapper from "@/components/wrappers/Link";
import { ASSETS_URL } from "@/config/deployConstants";
import Image from "next/image";
import styles from "./logo-slider.module.css";

const SCHOOLS = [
    { name: "Perrysburg", link: "https://www.perrysburgschools.net/" },
    { name: "Westford", link: "https://www.westfordk12.us/" },
    { name: "Lthaca", link: "https://www.ithacacityschools.org/" },
    { name: "Nardin", link: "https://www.nardin.org" },
    { name: "Yarmouth", link: "https://www.yarmouthschools.org" },
];

const LogoSlider = () => {
    return (
        <FlexRowAlignCenter style={{ width: "100%", padding: "5rem 0", overflow: "hidden" }}>
            <FlexRowAlignCenter
                className={styles.logosContainer}
                style={{
                    gap: "8rem",
                    paddingLeft: "5rem",
                    paddingRight: "5rem",
                }}>
                {Array.from({ length: 60 }, (_, index) => {
                    const school = SCHOOLS[index % 5];
                    return (
                        <LinkWrapper key={`school-${index + 1}`} href={school.link} target="_blank">
                            <Image
                                className={styles.logo}
                                src={`${ASSETS_URL}/images/schools/${school.name}.png`}
                                alt={school.name}
                                width={80}
                                height={80}
                                style={{
                                    width: "fit-content",
                                    objectFit: "contain",
                                }}
                            />
                        </LinkWrapper>
                    );
                })}
            </FlexRowAlignCenter>
        </FlexRowAlignCenter>
    );
};

export default LogoSlider;
